<div class="date-selection-container">
  <h2>{{ 'steps.dateSelection.title' | translate }}</h2>
  <p>{{ 'steps.dateSelection.subtitle' | translate }}</p>
  <div class="scheduler-container">
    <div class="week-controls-container">
      <div class="controls-container">
        <button nz-button (click)="previousWeek()">
          <span nz-icon nzType="left" nzTheme="outline"></span>
        </button>
        <button nz-button (click)="nextWeek()">
          <span nz-icon nzType="right" nzTheme="outline"></span>
        </button>
        <span class="day-selected-container">
          {{ 'steps.dateSelection.week_from' | translate }}
          <span class="day"> {{ getWeekStart() | date: 'EEEE dd' : 'UTC' : translateService.currentLang }} </span>
          {{ 'steps.dateSelection.at' | translate }}
          <span class="day"> {{ getWeekEnd() | date: 'EEEE dd' : 'UTC' : translateService.currentLang }} </span>
        </span>
      </div>

      <div class="datepicker-container">
        <span>{{ 'steps.dateSelection.choose_data' | translate }}</span>
        <nz-date-picker
          nzId="manualDate"
          [formControl]="manualDate"
          [nzPlaceHolder]="'steps.dateSelection.datepicker_placeholder' | translate"
          (ngModelChange)="onSelectedManualDateChange($event)"
          nzFormat="dd-MM-yyyy"
          nzShowToday
          [nzDefaultPickerValue]="currentStartDate"
          [nzDisabledDate]="checkDisabledDate"
          [nzAllowClear]="false"
        ></nz-date-picker>
      </div>
    </div>

    <nz-divider></nz-divider>

    <div class="days-hours-container">
      @for (day of dates; track day) {
        <ng-container>
          @if (isDateInCurrentWeek(day.date)) {
            <ng-container>
              <div class="day-hour-column">
                <div class="day-name">
                  {{ day.date | date: 'EEEE dd' : undefined : translateService.currentLang }}
                </div>

                <div class="hours">
                  @for (timeslot of day.timeslots; track timeslot) {
                    <label
                      nz-checkbox
                      [nzId]="day.date + timeslot.value"
                      [nzDisabled]="timeslot.disabled"
                      [(ngModel)]="timeslot.checked"
                      (ngModelChange)="selectedTimeslots(day.date, timeslot)"
                      >{{ timeslot.label }}</label
                    >
                  }
                </div>
              </div>
            </ng-container>
          }
        </ng-container>
      }
    </div>

    <nz-divider></nz-divider>

    @if (listSelectedAppointments.length > 0) {
      @if (listSelectedAppointments.length === maxAppointments) {
        <p>{{ 'steps.dateSelection.maximum_number_time_slots' | translate }}</p>
      }
      <div class="selected-dates-container">
        <p>{{ 'steps.dateSelection.times_indicated' | translate }}</p>
        @for (appointment of listSelectedAppointments; track appointment.label) {
          <span class="selected-date">
            <nz-tag>
              {{ appointment.date | date: 'EEEE dd' : undefined : translateService.currentLang }}{{ ', ' + appointment.time }}
              <span nz-icon nzType="close-circle" nzTheme="fill" (click)="deleteAppointment(appointment.date, appointment.time, true)" class="close-icon"></span>
            </nz-tag>
          </span>
        }
      </div>
    }
  </div>
</div>
